<div class="fc-confirm-close-dialog__content">
  <h1 mat-dialog-title class="fc-confirm-close-dialog__content__title">{{ data.title }}</h1>
  <div mat-dialog-content class="fc-confirm-close-dialog__content__description">
    <p class="fc-confirm-close-dialog__content__description__text">{{ data.description }}</p>
  </div>
  <div mat-dialog-actions class="fc-confirm-close-dialog__content__actions">
    <button
      mat-button
      class="fc-confirm-close-dialog__content__actions__unHighlightedButton"
      cdkFocusInitial
      (click)="unHighlightedButtonFunction()"
    >
      {{ data.unHighlightedButton }}
    </button>

    <button
      mat-button
      class="fc-confirm-close-dialog__content__actions__highlightButton"
      (click)="highlightButtonFunction()"
    >
      {{ data.highlightButton }}
    </button>
  </div>
</div>
